<template>
    <vx-card :title='$t("ProjectOffers")'>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="tableData">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} of {{ tableData.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="client">{{$t("Client")}}</vs-th>
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="user">{{$t("AssignedUser")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].client">
                        {{ data[index].client }}
                    </vs-td>

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td :data="data[index].user">
                        {{ data[index].user }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" :active.sync="addProjectOfferPrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="projectOfferAdding['name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Client")}}</p>
                <vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectOfferAdding['client_company_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyClients" />
                </vs-select>
                <p class="mt-6">{{$t("AssignedUser")}}</p>
                <vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectOfferAdding['company_user_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyUsers" />
                </vs-select>
                <p class="mt-6">{{$t("Description")}}</p>
                <vs-textarea v-model="projectOfferAdding['description']" class="w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addProjectOffer">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

    </vx-card>
</template>
<script>

    export default {
        data() {
            return {
                selected: {},
                projectOffers: [],

                itemsPerPage: 20,
                isMounted: false,

                addProjectOfferPrompt: false,

                projectOfferAdding: {},

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableData() {
                let data = [];
                for(let x = 0; x < this.projectOffers.length; x++){
                    data.push({
                        id: this.projectOffers[x].id,
                        client: this.$store.getters.companyClients[ this.projectOffers[x].client_company_id].name,
                        name: this.projectOffers[x].name,
                        user: this.$store.getters.companyUsers[this.projectOffers[x].company_user_id].name
                    })
                }

                return data;
            }
        },
        methods: {
            handleSelected(tr) {
                this.$router.push({ name: 'projectOffer', params: { id: tr.id } })
            },
            updateProjectOffers() {
                const thisIns = this;
                this.$http.get('/api/v1/projectOffer/')
                    .then(function (response) {
                        thisIns.projectOffers = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
        },
        created() {
            this.updateProjectOffers()
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addProjectOfferPrompt){
                this.addProjectOfferPrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }
</script>
